// components
import { DashboardComponent } from './dashboard.component';
import { NavigationComponent } from './navigation/navigation.component';
import { SETTINGS_COMPONENTS } from './settings/index';
import { MAIN_COMPONENTS } from './main/index';
import { PERSONAL_COMPONENTS } from './personal/index';
import { CONTRACTS_COMPONENTS } from './contracts/index';
import { FORSIGNING_COMPONENTS } from './for-signing/index';
import { HISTORY_COMPONENTS } from './history/index';
import { NOTIFICATIONS_COMPONENTS } from './notifications/index';
import { DOCUMENTS_COMPONENTS } from './documents/index';
import { COMMUNICATIONS_COMPONENTS } from './communications/index';

export const DASHBOARD_COMPONENTS: any[] = [
  DashboardComponent,
  NavigationComponent,
  SETTINGS_COMPONENTS,
  MAIN_COMPONENTS,
  PERSONAL_COMPONENTS,
  CONTRACTS_COMPONENTS,
  FORSIGNING_COMPONENTS,
  HISTORY_COMPONENTS,
  NOTIFICATIONS_COMPONENTS,
  DOCUMENTS_COMPONENTS,
  COMMUNICATIONS_COMPONENTS,
];

// services

// export const DASHBOARD_SERVICES: any[] = [
// ];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/index.ts